import {
  GetPlacesQuery,
  NotesFields,
  NotesType,
  PlaceCreationProvenance,
  PlaceFragment,
} from '@shared/generated/graphql';
import { Place } from '@shared/types/place';

export const placeFromFragment = (fragment: PlaceFragment): Place => {
  return {
    id: fragment.id,
    deletedAt: fragment.deletedAt ?? undefined,
    name: fragment.name ?? '',
    data: {
      primaryEmail: fragment.data?.primaryEmail ?? '',
      scheduleMaxDaysAhead: fragment.data?.scheduleMaxDaysAhead,
    },
    address: {
      addressOne: fragment.address?.addressOne ?? '',
      addressTwo: fragment.address?.addressTwo ?? '',
      city: fragment.address?.city ?? '',
      state: fragment.address?.state ?? '',
      zip: fragment.address?.zip ?? '',
      country: fragment.address?.country ?? '',
    },
    locationCode: fragment.locationCode ?? '',
    originator: {
      id: fragment.originator?.id ?? '',
      name: fragment.originator?.name ?? 'None',
    },
    tags: fragment.tags ?? [],
    aliases: fragment.aliases ?? [],
    creationProvenance:
      fragment.creationProvenance ?? PlaceCreationProvenance.UNKNOWN,
    notes: {
      internalNotes: getNotesByType(fragment.notes, NotesType.INTERNAL),
      externalNotes: getNotesByType(fragment.notes, NotesType.EXTERNAL),
    },
  };
};

export function getNotesByType(
  notes: NotesFields | null | undefined,
  notesType: NotesType
): string {
  const ns = notes?.notesFields?.filter((f) => f.notesType === notesType) ?? [];
  return ns.map((n) => n.notes).join('\n');
}

export const placesFromFragment = (query: GetPlacesQuery): Place[] => {
  return query.places.edges.map(({ node }) => placeFromFragment(node));
};
